import { Component, Vue, Prop } from 'vue-property-decorator';
import { statusOptions, StatusOptions } from '@/support/Status';
import { styledBoxOptions, StyledBoxOptions } from '@/support/StyledBox';
import { Options } from '@/components/mi-dialog/MiDialog';
import { Order } from '@/models/Order';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { sortObjectsArrayByProperty } from '@/support/String';

@Component<UpdateOrderDialog>({})
export default class UpdateOrderDialog extends Vue {
  @Prop({})
  protected selectedOrders !: any[];

  @Prop ()
  protected type !: string;

  protected isLoading: boolean = true;
  protected statusOptions: StatusOptions[] = sortObjectsArrayByProperty(statusOptions, 'value');
  protected styledBoxOptions: StyledBoxOptions[] = styledBoxOptions;

  protected selectedStatus: string = '';
  protected selectedStyledBox: string = '';

  protected close() {
    this.$emit('close', false);
  }

  protected update() {
    this.$store.dispatch('openDialog', this.dialogManyOptions);
  }

  get dialogManyOptions() : Options {
    const ordersId = this.selectedOrders.map((order: Order) => {
      return order.id;
    });

    return {
      title: 'Order updaten',
      text: `${this.selectedOrders.length} orders worden geupdate`,
      type: 'warning',
      buttons: {
        confirm: {
          text: 'Order updaten',
          action: () => {
            let payload: any = {
              orders: ordersId
            };

            if (this.type === 'status') {
              payload['new_status'] = this.selectedStatus
            }

            if (this.type === 'box-types') {
              payload['box_type'] = this.selectedStyledBox
            }

            new Order()
            .updateStatusType(payload, this.type)
            .then(() => {
              this.$emit('updated', false);
            })
            .catch((error: AxiosError) => {
              ErrorHandler.network(error);
            })
          },
        },
        cancel: {
          text: this.$t('dialogOptions.button.cancel').toString(),
          action: () => {
            this.close();
          },
        },
      },
    };
  }
}
